export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20Japanese%20manga%20style%20illustration%20with%20warm%20coral%20and%20amber%20gradient%20background%2C%20dynamic%20motion%20lines%2C%20stylized%20cherry%20blossom%20petals%20scattered%20across%20the%20scene%2C%20artistic%20comic%20panel%20abstract%20elements%2C%20soft%20warm%20lighting%2C%20dreamy%20atmosphere%2C%20no%20characters%2C%20clean%20artistic%20composition%2C%20literary%20and%20cultural%20vibe&width=1800&height=1200&seq=hero-bg-manga-01&orientation=landscape"
          alt="樱花漫画网背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4">
              <span className="px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-300 rounded-full border border-primary-400/30 whitespace-nowrap">
                每日更新
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/20 text-accent-300 rounded-full border border-accent-400/30 whitespace-nowrap">
                全集免费
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-secondary-500/20 text-secondary-300 rounded-full border border-secondary-400/30 whitespace-nowrap">
                下拉式阅读
              </span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
              樱花漫画网 - 全集漫画大全
              <br />
              免费完整版下拉式在线阅读
            </h1>

            <p className="text-base md:text-lg text-background-200/90 font-heading mb-5">
              好看的韩漫日漫国漫全本漫画，一次看个够
            </p>

            <p className="text-sm md:text-base text-background-200/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              樱花漫画网为您聚合海量优质漫画资源，涵盖热血、恋爱、悬疑、奇幻、都市、校园等全类型全本漫画作品。支持下拉式流畅阅读体验，无需翻页等待，全集漫画免费完整版随时随地想看就看。每日更新热门连载，韩漫日漫国漫一网打尽，好看的漫画尽在樱花漫画网。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">20000+</div>
                <div className="text-xs text-background-200/60 mt-1">全本漫画资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-400">每日更新</div>
                <div className="text-xs text-background-200/60 mt-1">热门连载同步</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-300">全免费</div>
                <div className="text-xs text-background-200/60 mt-1">完整版无删减</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
              >
                开始阅读热门漫画
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-3 border border-background-200/40 text-background-100 font-medium rounded-full hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
              >
                查看人气榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden border-2 border-background-200/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20manga%20art%20style%20illustration%20featuring%20a%20beautiful%20cherry%20blossom%20tree%20under%20moonlight%2C%20open%20books%20and%20scrolls%20floating%20with%20magical%20glowing%20particles%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20dreamy%20atmospheric%20lighting%2C%20soft%20gradients%2C%20artistic%20composition%2C%20literary%20theme%2C%20no%20human%20figures%2C%20elegant%20and%20refined%20visual%20style&width=800&height=1000&seq=hero-visual-manga-02&orientation=portrait"
                  alt="樱花漫画网主题视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-20 h-20 md:w-24 md:h-24 bg-primary-500 rounded-2xl flex items-center justify-center">
                <div className="text-center">
                  <div className="text-background-50 text-xs font-medium">NEW</div>
                  <div className="text-background-50 font-heading text-lg leading-none">热门</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}